import type { FormatterMap, ProductRoutesOptions, RouteList } from '@grandvisionhq/frk-routing'
import { createSimpleFormatter } from '@grandvisionhq/frk-routing'
import {
  createAuthFormatters,
  createCheckoutFormatters,
  createMyAccountFormatters,
  productDetailFormatters,
  productListFormatter,
} from '@grandvisionhq/www-next/formatters'

const productRoutesOptions: ProductRoutesOptions = {
  accessories: 'accessoires',
  'contact-lenses': 'lentilles',
  frames: 'lunettes-de-vue',
  'ready-readers': 'lunettes-premontees',
  solutions: 'lentilles/entretien',
  sunglasses: 'lunettes-de-soleil',
}

export const localRouteFormatters: FormatterMap = {
  home: createSimpleFormatter('/'),
  'cart.overview': createSimpleFormatter('cart'),
  'stores.overview': createSimpleFormatter('opticien'),
  'appointments.book': createSimpleFormatter('prendre-rendez-vous'),
  'appointments.cancel': createSimpleFormatter('cancel-appointment'),
  'appointments.reschedule': createSimpleFormatter('reschedule-appointment'),
  ...createMyAccountFormatters(),
  ...createAuthFormatters(),
  'express.checkout.login': createSimpleFormatter('express-user-checkout'),
  'express-checkout': createSimpleFormatter('express-checkout'),
  'order.confirm': createSimpleFormatter('order/confirm'),
  ...createCheckoutFormatters({
    path: 'checkout',
    children: {
      login: 'login',
      shipping: 'livraison',
      overview: 'recapitulatif',
      payment: 'paiement',
    },
  }),
  ...productListFormatter(productRoutesOptions),
  ...productDetailFormatters(productRoutesOptions),
  wishlist: createSimpleFormatter('/wishlist'),
}

export const routes: RouteList = [
  ['/', 'home'],

  ['/checkout/login', 'checkout.login'],
  ['/checkout/livraison', 'checkout.shipping'],
  ['/checkout/recapitulatif', 'checkout.overview'],
  ['/checkout/paiement', 'checkout.payment'],
  ['/api/payment-callback', 'payment.callback'],
  ['/order/confirm', 'order.confirm'],

  ['/prendre-rendez-vous{/*path}', 'appointments.book'],
  ['/modifier-rendez-vous', 'appointments.reschedule'],
  ['/annuler-rendez-vous', 'appointments.cancel'],
]
